import React, { ChangeEventHandler, FC, useEffect, useState } from 'react'

interface Props {
  label: string
  value?: string
  error?: string
  isLoading: boolean
  onChange: ChangeEventHandler<HTMLInputElement>
  onCancel?: () => void
}

const SummaryRowFormGroup: FC<Props> = ({ isLoading, label, value: initialValue = '', onChange, error, onCancel }) => {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    // setValue(initialValue)
  }, [initialValue])

  return (
    <>
      <span className="d-inline-block w-100 placeholder-text">{label}</span>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          disabled={isLoading}
          placeholder={label}
          value={value}
          autoFocus
          onChange={(event) => {
            setValue(event.currentTarget.value)
            onChange(event)
          }}
        />
        <div className="input-group-append">
          <button className="btn btn-secondary" disabled={isLoading} type="submit">
            {isLoading ? 'Saving' : 'Save'}
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        {error && <span className="d-block invalid-feedback flex-grow-1 mr-1">{error}</span>}
        {onCancel !== undefined && (
          <button
            type="button"
            disabled={isLoading}
            className="text-secondary btn btn-link px-3 ml-auto"
            onClick={onCancel}
          >
            Cancel
          </button>
        )}
      </div>
    </>
  )
}

export default SummaryRowFormGroup
